import React, { useEffect, useState } from 'react';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { connect } from "react-redux";
import { withRouter} from "react-router-dom";
import InfoModal from '../common/InfoModal';
import * as types from "../../constants/actionTypes";


const OnboardingModal = (props) => {
   
    useEffect(() => {
        logUI("MBHWeb.UI.OnboardingModal.ComponentDidMount", new Date(), Tools.getURLPath());
    }, [])

    const LogUpdatePath = (pathLog) => {
        logUI(`MBHWeb.UI.OnboardingModal.NavigationFrom.${pathLog}`, new Date(), Tools.getURLPath());
    }
    const modalOptions = { CONTINUE: 'continue', NOTHANKS: 'nothanks' };
    const path = location.pathname;
    const pathLog = path.substring(1);
    const [show, setShow] = useState(true);
    const toggle = () => setShow(!show);

    const modalClicked = (modalOption) => {
        toggle();
        if (modalOption === modalOptions.NOTHANKS) {
            LogUpdatePath(`${pathLog}`);
            props.history.push('/');
            props.updateFamilyMembersScreenPreference && props.updateFamilyMembersScreenPreference();
            props.updateInsurancePreferenceValue && props.updateInsurancePreferenceValue();
            props.updateNotificationsScreenPreference && props.updateNotificationsScreenPreference();
            props.updateScheduleCareToolTipPreference && props.updateScheduleCareToolTipPreference();
        }
    }
    const heading = "Finish setting up your account to get the most out of MyBSWHealth.";
    const title = "You’re almost done!";

    return (
        <>
            <InfoModal isOpen={show}
                alignText={"center"}
                className={"onboarding-modal"}
                hideBorder={true}
                modalBody={
                    <div className="col-12">
                        <h2>{title}</h2>
                        <p>{heading}</p>
                    </div>
                }
                modalFooter={
                    <div className="row link-container">
                        <div className="col-6 link-left"><button type="button" className="btn text-btn" onClick={() => modalClicked(modalOptions.CONTINUE)}>CONTINUE</button></div>
                        <div className="col-6 link-right"><button type="button" className="btn text-btn" onClick={() => modalClicked(modalOptions.NOTHANKS)}>NO THANKS</button></div>
                    </div>
                }
            />
        </>
    );
}
const mapStateToProps = (state) => {

    return {
        showOnboardingModal: state.session.showOnboardingModal,
    };
};

const mapDispatchToProps = (dispatch) => {

    return {
        updateFamilyMembersScreenPreference: () => dispatch({ type: types.UPDATE_FAMILYMEMBERS_SCREEN_PREFERENCE }),
        updateInsurancePreferenceValue: () => dispatch({ type: types.UPDATE_INSURANCE_PREFERENCE }),
        updateNotificationsScreenPreference: () => dispatch({ type: types.UPDATE_NOTIFICATIONS_SCREEN_PREFERENCE }),
        updateScheduleCareToolTipPreference: () => {dispatch({ type: types.UPDATE_SCHEDULE_CARE_TOOLTIP_PREFERENCE })
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OnboardingModal));
